import { initGlobalState } from 'qiankun';

const globalState = initGlobalState({
    currentSysGUID: "",
    currentUserFormID: ""
});

export default {
    // watch: {
    //     //一般来说点击菜单时触发
    //     async SelectedMenuKeys(val, old) {
    //         if (this.IsShowPreUserForm) {
    //             return Promise.resolve();
    //         }
            
    //         let _menuData = this.MenuDataMap[this.SelectedMenuKeys[0]];

    //         let _viewStateData = { IsShowPreUserForm: '0' };
            
    //         if (_menuData) {

    //             if (
    //                 _menuData.UserFormID === this.$route.params.ufid &&
    //                 Cgl.Url.GetParamFromUrl('ViewStateData') !== ''
    //             ) {
    //                 _viewStateData = $.parseJSON(
    //                     decodeURIComponent(
    //                         Cgl.Url.GetParamFromUrl('ViewStateData')
    //                     )
    //                 );
    //             }
                
    //             await CmnMis.Frame.ShowUserForm(
    //                 _menuData.UserFormID,
    //                 _viewStateData,
    //             );
    //         }
    //         else if(this.SelectedMenuKeys[0]) {
    //             //找不到直接替换显示
    //             await CmnMis.Frame.ShowUserForm(
    //                 this.SelectedMenuKeys[0].replace("f_", ""),
    //                 _viewStateData,
    //             );
    //         }
    //     }
    // },
    mounted() {
        this.IsShowPreUserForm = false;
        CmnMis.Frame.OnShowUserForm.Add(userform => {
            
            // this.IsShowPreUserForm = true;
            // const menuItem = this.FindMenuItemByUserForm(userform);
            // if (!menuItem) {
            //     this.IsShowPreUserForm = false;
            //     return;
            // }
            
            // if (!this.SelectedMenuKeys.includes(menuItem.Name)) {
            //     this.SelectedMenuKeys = [menuItem.Name];
            // }
            
            // this.$nextTick(() => {
            //     userform.OnLoad.Add(() => {
            //         let _menuData = this.MenuDataMap[this.SelectedMenuKeys[0]];

            //         if (_menuData) {
            //             globalState.setGlobalState({
            //                 currentSysGUID: _menuData.SubsysSysGuid || '',
            //                 currentUserFormID:
            //                     _menuData.SubsysUserFormID ||
            //                     _menuData.UserFormID
            //             });
            //         }
            //     });
            //     this.IsShowPreUserForm = false;
            // });

            //因为Frame触发OnShowUserForm后会清空当前userform的事件，
            //所以userform不能马上绑定OnLoad事件，需要等一下再绑定
            this.$nextTick(()=>{
                userform.OnLoad.Add(() => {
                    let _menuData = this.MenuDataMap[this.SelectedMenuKeys[0]];
    
                    if (_menuData) {

                        globalState.setGlobalState({
                            currentSysGUID: _menuData.SubsysSysGuid || '',
                            currentUserFormID:
                                _menuData.SubsysUserFormID ||
                                _menuData.UserFormID
                        });
                    }
                });
            });

            return userform;
        });
    }
};
